import { gql } from "@apollo/client"

export const EMPLOYMENT_SIGNATORY_FRAGMENT = gql(`
  fragment EmploymentSignatoryFragment on Employment {
    signatoryPointOfContact {
      id
      email
      fullName
      jobTitle
    }
  }
`)

export const COMPANY_SIGNATORY_FRAGMENT = gql(`
  fragment CompanySignatoryFragment on Company {
    authorizations {
      actions
    }
    activePointsOfContact(areaOfDomain: "Signatory", perPage: 400) {
      collection {
        id
        areasOfDomain
        email
        fullName
        jobTitle
      }
    }
    signatoryPointOfContact {
      id
      email
      fullName
      jobTitle
    }
  }
`)
